import { PaymentMethod } from "./payment-method";

export enum TransactionStatus {
  reversed = 'REVERSED',
  rejected = 'REJECTED',
  approved = 'APPROVED',
  failed = 'FAILED',
}

export enum OperationType {
  payment = 'PAYMENT',
  refund = 'REFUND',
  annulment = 'ANNULMENT'
}

export enum CardBrand {
  visa = 'VISA',
  mastercard = 'MASTERCARD',
  amex = 'AMEX',
  wuzi = 'WUZI',
  otras = 'OTRAS'
}

export enum Currency {
  ars= 'ARS',
  mex = 'MXN'
}

export interface Transaction {
  id: string;
  branch_name: string;
  card_mask: string;
  card_brand: string;
  cbu: string;
  currency: Currency;
  date_time: string;
  description: string;
  financing: string;
  financial_discount_on_installments: number;
  gross_amount: number;
  installments: number;
  merchant_fee: number;
  merchant_id: string;
  merchant_name: string;
  net_amount: number;
  operation_additional_info: string;
  operation_id: string;
  operation_number: string;
  operation_amount: number;
  operation_status: string;
  operation_type: OperationType;
  payment_card_owner: string;
  payment_date: string;
  payment_method_detail: string;
  payment_method_type: PaymentMethod;
  reference_operation_id: string;
  reference_operation_number: string;
  serial_number: string;
  status: TransactionStatus;
  term: number;
  terminal_id: string;
  ticket_id: string;
  tip_amount: number;
  total_financial_discount_on_installments: number;
  total_merchant_fee: number;
  user: string;
  vat_on_financial_discount_on_installments: number;
  vat_on_merchant_fee: number;
  authorization_code: string;
  total_taxes_and_fees: number;
}
